import { useContext } from 'react';
import { find } from 'lodash';

import { SubscriptionContext } from './context';

const useSubscriptions = (subscription) => {
  const { subscriptions } = useContext(SubscriptionContext);

  if (Array.isArray(subscription)) {
    return subscription.map(s =>
      find(subscriptions, ['id', s]));
  } else if (typeof subscription === 'string') {
    return find(subscriptions, ['id', subscription]);
  }

  return subscriptions;
};

export default useSubscriptions;
